import { Injectable } from '@angular/core';

import { Colour } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ColourService extends TmsWebBaseEditService<Colour, Colour> {
  constructor() {
    super('Colour', $localize`Colour`);
  }
}
